/**
 * US ZIP code to state lookup.
 *
 * The first three digits of a US ZIP code (the sectional center) belong to a
 * single state, so the state can be filled in as soon as the applicant has typed
 * a full 5 digit ZIP, with no API call. A few border towns are served by a
 * neighbouring state's post office; the known ones are in EXCEPTIONS. Territory
 * ZIPs (PR, VI, GU, AS) resolve to nothing because the state lists don't carry
 * them. The applicant can always change the State after it is filled.
 *
 * Checked against the USPS L002 3-digit prefix matrix and the current USPS ZIP 3
 * by district list, the Census 2020 ZCTA to county file and the GeoNames US
 * postal code list. What still disagrees: a dozen ZIPs whose area spans two
 * states, and two Homeland Security mail-only ZIPs (20588, 20598) nobody lives in.
 *
 * Usage: UsZipState.lookup('02134') returns 'MA', or null when the input is not
 * a 5 digit US ZIP we can place. UsZipState.fill(zipInput, stateSelect) sets the
 * state select (plain or Choices) from the ZIP and fires its change event; it
 * returns true when it changed the selection.
 */
(function (window) {
    'use strict';

    // [first prefix, last prefix, state]; gaps are territory or unassigned prefixes. A
    // range can also cover a few unassigned prefixes inside its state's block.
    var RANGES = [
        [5, 5, 'NY'],
        [10, 27, 'MA'],
        [28, 29, 'RI'],
        [30, 38, 'NH'],
        [39, 49, 'ME'],
        [50, 54, 'VT'],
        [55, 55, 'MA'],
        [56, 59, 'VT'],
        [60, 69, 'CT'],
        [70, 89, 'NJ'],
        [90, 99, 'AE'],
        [100, 149, 'NY'],
        [150, 196, 'PA'],
        [197, 199, 'DE'],
        [200, 200, 'DC'],
        [201, 201, 'VA'],
        [202, 205, 'DC'],
        [206, 219, 'MD'],
        [220, 246, 'VA'],
        [247, 268, 'WV'],
        [270, 289, 'NC'],
        [290, 299, 'SC'],
        [300, 319, 'GA'],
        [320, 339, 'FL'],
        [340, 340, 'AA'],
        [341, 349, 'FL'],
        [350, 369, 'AL'],
        [370, 385, 'TN'],
        [386, 397, 'MS'],
        [398, 399, 'GA'],
        [400, 427, 'KY'],
        [430, 459, 'OH'],
        [460, 479, 'IN'],
        [480, 499, 'MI'],
        [500, 528, 'IA'],
        [530, 549, 'WI'],
        [550, 567, 'MN'],
        [569, 569, 'DC'],
        [570, 577, 'SD'],
        [580, 588, 'ND'],
        [590, 599, 'MT'],
        [600, 629, 'IL'],
        [630, 658, 'MO'],
        [660, 679, 'KS'],
        [680, 693, 'NE'],
        [700, 714, 'LA'],
        [716, 729, 'AR'],
        [730, 731, 'OK'],
        [733, 733, 'TX'],
        [734, 749, 'OK'],
        [750, 799, 'TX'],
        [800, 816, 'CO'],
        [820, 831, 'WY'],
        [832, 838, 'ID'],
        [840, 847, 'UT'],
        [850, 865, 'AZ'],
        [870, 884, 'NM'],
        [885, 885, 'TX'],
        [889, 898, 'NV'],
        [900, 961, 'CA'],
        [962, 966, 'AP'],
        [967, 968, 'HI'],
        [970, 979, 'OR'],
        [980, 994, 'WA'],
        [995, 999, 'AK']
    ];

    // Full ZIPs whose state differs from their prefix's state; null = no state.
    var EXCEPTIONS = {
        '06390': 'NY', // Fishers Island, served from New London CT
        '72643': 'MO', // Lead Hill MO; Lead Hill AR is 72644
        '73960': 'TX', // Texhoma TX; Texhoma OK is 73949
        '83414': 'WY', // Alta, served from Driggs ID
        '96799': null  // Pago Pago, American Samoa, inside Hawaii's prefix
    };

    function lookup(zip) {
        var digits = String(zip == null ? '' : zip).replace(/\D/g, '');
        var prefix;
        var i;

        if (digits.length !== 5) {
            return null;
        }

        if (Object.prototype.hasOwnProperty.call(EXCEPTIONS, digits)) {
            return EXCEPTIONS[digits];
        }

        prefix = parseInt(digits.slice(0, 3), 10);
        for (i = 0; i < RANGES.length; i++) {
            if (prefix >= RANGES[i][0] && prefix <= RANGES[i][1]) {
                return RANGES[i][2];
            }
        }

        return null;
    }

    function fill(zipInput, stateSelect) {
        var state;
        var hasOption;

        if (!zipInput || !stateSelect || stateSelect.tagName !== 'SELECT') {
            return false;
        }

        state = lookup(zipInput.value);
        hasOption = state && Array.prototype.some.call(stateSelect.options, function (option) {
            return option.value === state;
        });
        if (!hasOption || stateSelect.value === state) {
            return false;
        }

        if (stateSelect.choicesInstance) {
            stateSelect.choicesInstance.setChoiceByValue(state);
        } else {
            stateSelect.value = state;
        }
        // A native event reaches jQuery and inline handlers alike, and an error in
        // one of them stays in that handler instead of aborting the caller.
        stateSelect.dispatchEvent(new Event('change', { bubbles: true }));

        return true;
    }

    window.UsZipState = {
        lookup: lookup,
        fill: fill
    };
})(window);
